import {createSelector} from "@reduxjs/toolkit";
import {RootStore} from "./rootStore";
import {RequestParams} from "../api/RequestParams";
import {SORT_BY_FIELDS} from "../data/defaults";

export const getParams = createSelector((state: RootStore) => ({
    filters: state.searchResult.filters,
    currentPage: state.searchResult.currentPage,
    pageSize: state.searchResult.pageSize,
    sortField: state.searchResult.sortField,
}), ({filters, currentPage, pageSize, sortField}) => {
    return new RequestParams({
            ...filters
        },
        {
            field: sortField,
            direction: SORT_BY_FIELDS.find(i => i.id == sortField)?.desc ? "desc" : "asc"
        },
        {
            size: pageSize,
            number: currentPage
        }
    );
});